import { WorkflowNode } from './workflow-node.model';
import { WorkflowNodeType } from './workflow-node-type.enum';
import { WorkflowNodeRuleType } from './workflow-node-rule-type.enum';
import { WorkflowNodeActionType } from './workflow-node-action-type.enum';

const RULE_LABELS: Record<WorkflowNodeRuleType, string> = {
  [WorkflowNodeRuleType.Condition]: 'Condition',
  [WorkflowNodeRuleType.WaitForTrigger]: 'Wait for Trigger',
  [WorkflowNodeRuleType.TimeDelay]: 'Time Delay'
};

const ACTION_LABELS: Record<WorkflowNodeActionType, string> = {
  [WorkflowNodeActionType.SendEmail]: 'Send Email',
  [WorkflowNodeActionType.Webhook]: 'Webhook'
};

const TYPE_LABELS: Record<WorkflowNodeType, string> = {
  [WorkflowNodeType.Trigger]: 'Trigger',
  [WorkflowNodeType.Terminator]: 'Terminator',
  [WorkflowNodeType.Rule]: 'Rule',
  [WorkflowNodeType.Action]: 'Action'
};

/**
 * What a node is known by wherever it is shown: the sub-type where there is
 * one, so "Time Delay", not "rule". Spelled out rather than returning the enum
 * value, which would read as "waitForTrigger" — the bare-type labels are
 * fallbacks for a node whose sub-type is unset.
 */
export function nodeTypeLabelFor(node: Pick<WorkflowNode, 'type' | 'ruleType' | 'actionType'>): string {
  if (node.type === WorkflowNodeType.Rule && node.ruleType) return RULE_LABELS[node.ruleType];
  if (node.type === WorkflowNodeType.Action && node.actionType) return ACTION_LABELS[node.actionType];
  return TYPE_LABELS[node.type];
}
